import { Container, Card, CardHeader, Heading, CardBody, Text, Divider } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useAppDispatch } from "store/store.hook";
import { useState } from "react";
import { SubTarget } from "types/SubTarget";
import ChartSeries from "./ChartSeries";
import MyBreadcrumb from "components/breadcrumb/Breadcrumb";
import { Breadcrumb } from "types/Breadcrumb";


/**
 * The `Charts` component is responsible for rendering the charts related to a specific target.
 * It fetches the necessary data from the Redux store, constructs a breadcrumb for navigation,
 * and displays the charts using the `ChartSeries` component.
 *
 * @returns {JSX.Element} The rendered component.
 *
 * @remarks
 * This component uses several hooks:
 * - `useAppDispatch` to dispatch actions to the Redux store.
 * - `useParams` to get the URL parameters.
 * - `useSelector` to select data from the Redux store.
 *
 * The component retrieves the following data:
 * - `selectedDocumentId`: The ID of the selected document.
 * - `selectedDocument`: The selected document object.
 * - `target`: The target object within the selected document that matches the `targetIndex` parameter.
 * - `timePeriods`: The time periods associated with the selected document.
 * - `sources`: The divisions data from the Redux store.
 *
 The breadcrumb is constructed with three levels:
 * - "Obiettivi" linking to the targets overview.
 * - "Obiettivo {targetIndex}" linking to the specific target.
 * - "Visualizzazione grafici" indicating the current view.
 *
 * The component renders a section containing a breadcrumb, a card with the target's title and description,
 * and the `ChartSeries` component to display the charts.
 */
export default function Charts() {

  const dispatch = useAppDispatch();
  const params = useParams();
  const { targetIndex } = params;
  const selectedDocumentId = useSelector((state: any) => state.documents.selectedDocumentId);
  const selectedDocument = (useSelector((state: any) => state.documents.documents.find((doc: any) => doc._id === selectedDocumentId)));
  const target = selectedDocument.targets.find((target: any) => target.index === targetIndex);
  const timePeriods = selectedDocument.timePeriods;
  const sources = useSelector((state: any) => state.divisions.divisions);

  const breadcrumb: Breadcrumb = new Breadcrumb(
    [
      { label: "Obiettivi", link: "/targets", value: "", isActive: true },
      { label: `Obiettivo ${targetIndex}`, link: `/targets/${targetIndex}`, value: "", isActive: false },
      { label: `Visualizzazione grafici`, link: `/targets/${targetIndex}/charts`, value: "", isActive: true },
    ]
  );




  return (


    <section className="dashboard-first-section">
      <Container maxW="container.lg" maxH={"container.xl"} textAlign={"left"}>
        <MyBreadcrumb breadcrumb={breadcrumb}/>

        <Card minH={"60vh"}>
          <CardHeader>
            <Heading as="h1" size="xl" >
              Obiettivo {targetIndex} - {target.title} | Visualizzazione Grafici
            </Heading>
            <Text>
              {target?.description}
            </Text>
            <Divider />
          </CardHeader>
          <CardBody>
            <ChartSeries target={target} timePeriods={timePeriods} divisions={sources} />
          </CardBody>
        </Card>
      </Container>
    </section>

  )

}
